import VLFSelectNew from "@/components/Input/SelectNew";
import {PERMISSION_AREAS, ACCESS_LEVELS} from "@/utils/constants";
import {AREAS} from "@/utils/access";

import "./index.scss";

// Editor permessi-area riusabile.
// - value/baseline: array [{area, accessLevel}] (shape API)
// - mode "role": lo stato "vuoto" è "Nessuno" (nessun accesso)
// - mode "user": lo stato "vuoto" è "Eredita" (dal ruolo); baseline mostra il livello ereditato
// - onChange restituisce il nuovo array (aree con override; le "vuote" sono assenti)
// Si mostrano solo le aree che l'app usa: le altre ("Sviluppo") restano invariate nel valore.
const VISIBLE_AREAS = PERMISSION_AREAS.filter((a) =>
	Object.values(AREAS).includes(a.key),
);

function AreaPermissionsEditor({
	value = [],
	baseline,
	mode = "user",
	onChange,
}) {
	const valueMap = {};
	(value || []).forEach((p) => (valueMap[p.area] = p.accessLevel));
	const baselineMap = {};
	(baseline || []).forEach((p) => (baselineMap[p.area] = p.accessLevel));

	const levelLabel = (lvl) =>
		lvl === ACCESS_LEVELS.FULL_CONTROL
			? "Vede e modifica"
			: lvl === ACCESS_LEVELS.READ_ONLY
				? "Solo lettura"
				: "Nessun accesso";

	const emptyLabel = (area) =>
		mode === "user"
			? `Eredita${baseline ? ` · ${levelLabel(baselineMap[area])}` : ""}`
			: "Nessuno";

	const optionsFor = (area) => [
		{value: "", label: emptyLabel(area)},
		{value: ACCESS_LEVELS.READ_ONLY, label: "Solo lettura"},
		{value: ACCESS_LEVELS.FULL_CONTROL, label: "Vede e modifica"},
	];

	const handleChange = (area, option) => {
		const lvl = option?.value || "";
		const next = (value || []).filter((p) => p.area !== area);
		if (lvl) next.push({area, accessLevel: lvl});
		onChange && onChange(next);
	};

	return (
		<div className="area-permissions-editor">
			{VISIBLE_AREAS.map((a) => {
				const options = optionsFor(a.key);
				const current = valueMap[a.key] || "";
				const selected = options.find((o) => o.value === current);
				return (
					<div className="area-permissions-editor__row" key={a.key}>
						<div className="area-permissions-editor__label">{a.label}</div>
						<div className="area-permissions-editor__control">
							<VLFSelectNew
								options={options}
								sorted={false}
								value={selected}
								onChange={(opt) => handleChange(a.key, opt)}
							/>
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default AreaPermissionsEditor;
